import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import ServiceProductGridItem from './ServiceProductGridItem';
import { ServiceProductItem } from 'model/modules/services/serviceProductItem';

interface Props {
  items: ServiceProductItem[];
}

const ServiceProductsGrid: FC<Props> = ({ items }) => {
  const gapBetweenCards = 16;

  return (
    <Flex flexWrap="wrap" gap={`${gapBetweenCards}px`}>
      {items.map((product) => (
        <ServiceProductGridItem
          key={product.id}
          product={product}
          w={`calc(100% / 3 - ${(gapBetweenCards * 2) / 3}px)`}
        />
      ))}
    </Flex>
  );
};

export default ServiceProductsGrid;
